import { render, staticRenderFns } from "./BreakingNewsCard.vue?vue&type=template&id=7ac4fa3f&scoped=true"
import script from "./BreakingNewsCard.vue?vue&type=script&lang=js"
export * from "./BreakingNewsCard.vue?vue&type=script&lang=js"
import style0 from "./BreakingNewsCard.vue?vue&type=style&index=0&id=7ac4fa3f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ac4fa3f",
  null
  
)

export default component.exports